import styled from "styled-components";

const Linha = styled.div`
	height: 1px;
	background-color: var(--corEscrita);
	margin: ${props => props.$margem || "0 20px"};
`

export default Linha;